import { render } from "./forgetPassword.vue?vue&type=template&id=6457970e"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"

import "./forgetPassword.vue?vue&type=style&index=0&id=6457970e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__